const messageRegEx = /^['"a-zA-Z0-9\s.,!?-]*$/;

export default messageRegEx;
